import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useState } from "react";
import { useSelector } from "react-redux";
import { useDebounce } from "use-debounce";
import { PrivatePopularSmartTags } from "~/components/Filters/SmartTagsFilter/PrivatePopularSmartTags";
import { SmartTagsSelect } from "~/components/SmartTagSelect/SmartTagsSelect";
import { convertSmartTagToSelectOption } from "~/components/SmartTagSelect/utils";
import { useURLLibraryIdSelector } from "~/hooks/useURLLibraryIdSelector";
import { useCurrentWorkspace } from "~/providers/CurrentWorkspaceProvider";
import { centralizedBoardSelector } from "~/store/centralizedBoard/selectors";
import { useGetPrivateSmartTagList } from "~/swr-hooks/filters/useGetPrivateSmartTagList";
export const PrivateSmartTagsSelect = /*#__PURE__*/ memo((param)=>{
    let { selectedSmartTags = [], onSelectedSmartTagsChanged, className, ...props } = param;
    var _board_library;
    const [searchValue, setSearchValue] = useState("");
    const board = useSelector(centralizedBoardSelector);
    const libraryId = useURLLibraryIdSelector();
    const [debouncedSearchValue] = useDebounce(searchValue, 200, {
        trailing: true
    });
    const { currentWorkspace } = useCurrentWorkspace();
    const { data = [], isLoading } = useGetPrivateSmartTagList({
        search: debouncedSearchValue,
        boardId: board === null || board === void 0 ? void 0 : board.id,
        libraryId: libraryId !== null && libraryId !== void 0 ? libraryId : board === null || board === void 0 ? void 0 : (_board_library = board.library) === null || _board_library === void 0 ? void 0 : _board_library.id,
        workspaceId: currentWorkspace === null || currentWorkspace === void 0 ? void 0 : currentWorkspace.id
    });
    const onSelectionChange = useCallback((values)=>{
        const baseSmartTags = values.map((param)=>{
            let { value, label } = param;
            return {
                id: value,
                label
            };
        });
        onSelectedSmartTagsChanged(baseSmartTags);
    }, [
        onSelectedSmartTagsChanged
    ]);
    const onSmartTagClick = useCallback((smartTag)=>{
        onSelectedSmartTagsChanged([
            {
                id: smartTag,
                label: smartTag
            }
        ]);
    }, [
        onSelectedSmartTagsChanged
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: className,
        children: [
            /*#__PURE__*/ _jsx(SmartTagsSelect, {
                smartTags: data.map((smartTag)=>({
                        id: smartTag,
                        label: smartTag
                    })),
                isLoading: isLoading,
                selectedSmartTags: selectedSmartTags.map((smartTag)=>convertSmartTagToSelectOption(smartTag)),
                onSmartTagsSelectionChange: onSelectionChange,
                onInputChange: setSearchValue,
                ...props
            }),
            !selectedSmartTags.length && /*#__PURE__*/ _jsx(PrivatePopularSmartTags, {
                className: "mt-3",
                onSmartTagClick: onSmartTagClick
            })
        ]
    });
});
PrivateSmartTagsSelect.displayName = "PrivateSmartTagsSelect";
